export default __webpack_public_path__ + "static/media/circled-add.e973dc75.svg";